export default "query publicationTypes{\n    publicationTypes\n}";